import React, { useRef, useState } from "react";

export default function ContactForm() {
  // Antibot honeypot en state
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const emailTarget = ["stephen", "_01_", "@hotmail", ".com"].join(""); // niet als e-mail in source!
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const data = new FormData(formRef.current);

    // Honeypot check
    if (data.get("extra_field")) {
      setError("Spam gedetecteerd. Formulier niet verzonden.");
      return;
    }

    // Valideer minimaal e-mail en reden
    if (
      !data.get("email") ||
      !data.get("reden") ||
      !/^[^@]+@[^@]+\.[^@]+$/.test(data.get("email"))
    ) {
      setError("Vul een geldig e-mailadres en reden in.");
      return;
    }

    // --- Voorbeeld: E-mail versturen met Formspree, vervang met je eigen backend indien gewenst
    try {
      // Vervang onderstaande fetch-url door je eigen backend endpoint of Formspree-url
      const response = await fetch("https://formspree.io/f/mayrvznb", {
        // TODO: je eigen Formspree endpoint aanmaken en invullen!
        method: "POST",
        headers: { Accept: "application/json" },
        body: data,
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        setError("Verzenden mislukt. Probeer later opnieuw.");
      }
    } catch (err) {
      setError("Er ging iets mis bij het verzenden.");
    }
  };

  return (
    <div style={{
      maxWidth: 540,
      margin: "4rem auto",
      padding: "2.5rem 1.3rem",
      background: "#fff",
      borderRadius: 18,
      boxShadow: "0 2px 32px 0 rgba(31,38,135,0.11)"
    }}>
      <h1 style={{ color: "#2247d5", marginBottom: 18, fontWeight: 900 }}>
        Contact & Accountverwijdering
      </h1>
      <p style={{ color: "#444", marginBottom: 18 }}>
        Heb je een vraag, wil je feedback delen, of je account laten verwijderen? Vul onderstaand formulier in. Wij behandelen je verzoek zo spoedig mogelijk.
      </p>

      {submitted ? (
        <div style={{ color: "#4b8cf6", fontWeight: 600, fontSize: "1.18rem", minHeight: 120 }}>
          <span role="img" aria-label="check">✅</span>  
          Je bericht is succesvol verzonden.<br />
          Je ontvangt spoedig een reactie van ons team.
        </div>
      ) : (
        <form ref={formRef} onSubmit={handleSubmit} autoComplete="off" spellCheck="false">
          {/* Onzichtbare honeypot */}
          <div style={{ display: "none" }}>
            <label>
              Niet invullen:&nbsp;
              <input type="text" name="extra_field" tabIndex={-1} autoComplete="off" />
            </label>
          </div>
          {/* E-mail */}
          <div style={{ marginBottom: 17 }}>
            <label htmlFor="email" style={{ color: "#2247d5", fontWeight: 600 }}>
              E-mailadres <span style={{ color: "#f00" }}>*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              style={{
                width: "100%",
                padding: "0.65rem 1rem",
                fontSize: "1rem",
                borderRadius: 8,
                border: "1.3px solid #ccd7ee",
                marginTop: 6,
              }}
              autoComplete="off"
              inputMode="email"
            />
          </div>
          {/* Telefoonnummer */}
          <div style={{ marginBottom: 17 }}>
            <label htmlFor="telefoon" style={{ color: "#2247d5", fontWeight: 600 }}>
              Telefoonnummer
            </label>
            <input
              type="tel"
              id="telefoon"
              name="telefoon"
              style={{
                width: "100%",
                padding: "0.65rem 1rem",
                fontSize: "1rem",
                borderRadius: 8,
                border: "1.3px solid #ccd7ee",
                marginTop: 6,
              }}
              autoComplete="off"
              inputMode="tel"
            />
          </div>
          {/* Laatste werkgever */}
          <div style={{ marginBottom: 17 }}>
            <label htmlFor="werkgever" style={{ color: "#2247d5", fontWeight: 600 }}>
              Laatste werkgever
            </label>
            <input
              type="text"
              id="werkgever"
              name="werkgever"
              style={{
                width: "100%",
                padding: "0.65rem 1rem",
                fontSize: "1rem",
                borderRadius: 8,
                border: "1.3px solid #ccd7ee",
                marginTop: 6,
              }}
              autoComplete="off"
            />
          </div>
          {/* 10 laatste diensten */}
          <div style={{ marginBottom: 17 }}>
            <label htmlFor="diensten" style={{ color: "#2247d5", fontWeight: 600 }}>
              Omschrijving van de 10 laatste ingevoerde diensten
            </label>
            <textarea
              id="diensten"
              name="diensten"
              rows={3}
              style={{
                width: "100%",
                padding: "0.7rem 1rem",
                fontSize: "1rem",
                borderRadius: 8,
                border: "1.3px solid #ccd7ee",
                marginTop: 6,
                resize: "vertical",
              }}
              autoComplete="off"
              placeholder="Bijvoorbeeld: Datum, soort dienst, aantal uren..."
            />
          </div>
          {/* Reden voor verwijderen */}
          <div style={{ marginBottom: 20 }}>
            <label htmlFor="reden" style={{ color: "#2247d5", fontWeight: 600 }}>
              Reden van contact / Reden van accountverwijdering <span style={{ color: "#f00" }}>*</span>
            </label>
            <textarea
              id="reden"
              name="reden"
              required
              rows={2}
              style={{
                width: "100%",
                padding: "0.7rem 1rem",
                fontSize: "1rem",
                borderRadius: 8,
                border: "1.3px solid #ccd7ee",
                marginTop: 6,
                resize: "vertical",
              }}
              placeholder="Waarom neem je contact op? (bijv. account verwijderen, vraag, klacht, etc.)"
            />
          </div>
          {/* Foutmelding */}
          {error && (
            <div style={{ color: "#f00", marginBottom: 12, fontWeight: 600 }}>
              {error}
            </div>
          )}
          {/* Submit */}
          <button
            type="submit"
            style={{
              background: "linear-gradient(90deg,#2247d5 40%,#4b8cf6 100%)",
              color: "#fff",
              fontWeight: 700,
              border: "none",
              borderRadius: 9,
              padding: "0.85rem 2.3rem",
              fontSize: "1.14rem",
              boxShadow: "0 2px 12px #2247d522",
              cursor: "pointer",
              transition: "background 0.2s",
            }}
          >
            Verstuur bericht
          </button>
        </form>
      )}
      {/* Info footer */}
      <div style={{
        marginTop: 28,
        fontSize: "0.96rem",
        color: "#888",
        textAlign: "center"
      }}>
        Je gegevens worden vertrouwelijk behandeld.<br />
        Alleen ingevulde gegevens worden doorgestuurd naar ons team.<br />
        <span style={{ fontSize: "0.86rem" }}>
          Voor privacy-informatie zie onze <a href="/privacy" style={{ color: "#4b8cf6" }}>privacyverklaring</a>.
        </span>
      </div>
    </div>
  );
}
